@if(viewBanner){
<!-- Start::banner (lg+) -->
<div class="sM:col-12 p-0 hidden lg:block">
  <a [href]="bannerCms.buttonUrl" (click)="onClickBanner(bannerCms.title)">
    <img
      [src]="bannerCms.imageClassic"
      [alt]="bannerCms.alt"
      [title]="bannerCms.title"
      class="img-fluid"
      style="width: 100%; height: 100%"
    />
  </a>
</div>
<!-- End::banner (lg+) -->

<!-- Start::banner (xs, sm y md) -->
<div
  class="sm:col-12 flex justify-content-center align-items-center p-0 block lg:hidden"
>
  <a [href]="bannerCms.buttonUrl" (click)="onClickBanner(bannerCms.title)">
    <img
      [src]="bannerCms.imageMobile"
      [alt]="bannerCms.alt"
      [title]="bannerCms.title"
      style="width: 100%; height: 100%"
    />
  </a>
</div>
<!-- Start::banner (xs, sm y md) -->
}
